var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import e from "../../node_modules/uuid/dist/esm-browser/v4.js";
class t {
  static generateKey() {
    const t2 = e();
    return localStorage.setItem(this.STORAGE_KEY, t2), t2;
  }
  static getKey() {
    return localStorage.getItem(this.STORAGE_KEY);
  }
  static clearKey() {
    localStorage.removeItem(this.STORAGE_KEY);
  }
  static ensureKey() {
    let e2 = this.getKey();
    return e2 || (e2 = this.generateKey()), e2;
  }
}
__publicField(t, "STORAGE_KEY", "idempotence-key");
export {
  t as IdempotenceKeyManager
};
//# sourceMappingURL=idempotenceKeyManager.js.map
